import { DataNode } from 'antd/lib/tree';
import { makeAutoObservable, observable } from 'mobx';

import { FileTypeEnum, LogConvertRes } from '@/api';
import {
  FileItem,
  MCodeMirrorRefType,
} from '@/component/m-common/m-code-mirror';

type LogAnalyzeStoreState = {
  logCurrentFileUrl: string;
  totalZipUrl: string;
  selectedSceneId: string;
  selectedFile: FileItem;
  selectedKeys: React.Key[];
  expandKeys: React.Key[];
  mCodeMirrorRef: MCodeMirrorRefType | null;
  logAnalyzeMode: 'agent' | 'ask';
  logType: FileTypeEnum;
  /** 当前日志文件主文件url */
  parentLogCurrentFileUrl: string;
  /** 子文件的cosUrl对应的key */
  childCosUrlKey: string;
  /** 文件树数据 */
  fileTree: LogConvertRes;
  /** 额外文件树数据列表 */
  extraFileTreeList: LogConvertRes[];
  /** 当前选中文件所属的文件树 */
  currentSelectFileTree: LogConvertRes | null;
  /** 文件树节点数据 */
  treeData: DataNode[];
  /** 默认展开的键 */
  defaultExpandKeys: React.Key[];
  /** 文件内容加载状态 */
  loading: boolean;
  /** 文件树加载状态 */
  fileTreeLoading: boolean;
  /** 加载消息列表 */
  loadingMessages: string[];
  /** 业务参数 */
  businessParams: { keyword?: string; cosUrl?: string } | null;
};

export type LogAnalyzeStoreStateKeys = keyof LogAnalyzeStoreState;
/** 日志分析相关信息 STORE */
class LogAnalyzeStore {
  @observable public logCurrentFileUrl: string = '';
  @observable public totalZipUrl: string = '';
  @observable public selectedSceneId: string = '';
  @observable public selectedFile: FileItem = null!;
  @observable public selectedKeys: React.Key[] = [];
  @observable public expandKeys: React.Key[] = [];
  @observable public logAnalyzeMode: 'agent' | 'ask' = 'agent';
  @observable public logType: FileTypeEnum | null = null;
  @observable public childCosUrlKey: string = '';
  @observable public parentLogCurrentFileUrl: string = '';
  @observable public fileTree: LogConvertRes = {
    full_path: '',
    file_name: '',
    type: 'directory',
  };
  @observable public extraFileTreeList: LogConvertRes[] = [];
  @observable public currentSelectFileTree: LogConvertRes | null = null;
  @observable public treeData: DataNode[] = [];
  @observable public defaultExpandKeys: React.Key[] = [];
  @observable public loading: boolean = false;
  @observable public fileTreeLoading: boolean = false;
  @observable public loadingMessages: string[] = [];
  @observable public businessParams: {
    keyword?: string;
    cosUrl?: string;
  } | null = null;
  public mCodeMirrorRef: MCodeMirrorRefType | null = null;

  public constructor() {
    makeAutoObservable(this, {
      // 明确告诉 MobX 不要观察 mCodeMirrorRef
      mCodeMirrorRef: false,
    });
  }

  /** 通用设置方法 */
  public setState<K extends LogAnalyzeStoreStateKeys>(key: K, value: this[K]) {
    this[key] = value;
  }

  /** 批量设置方法 */
  public setStates<K extends keyof LogAnalyzeStoreState>(
    states: Pick<LogAnalyzeStoreState, K>
  ) {
    Object.entries(states).forEach(([key, value]) => {
      this.setState(key as K, value as this[K]);
    });
  }
  public reset() {
    // 重置为初始状态
    Object.assign(this, new LogAnalyzeStore());
  }
}

/** 业务信息 STORE */
const LOG_ANALYZE_STORE = new LogAnalyzeStore();

export type TLogAnalyzeStore = typeof LOG_ANALYZE_STORE;

export default LOG_ANALYZE_STORE;
